import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import ModalFooter from 'CommonComponents/ModalFooter';
import TextFormField from 'CommonComponents/TextFormField';

const ExpenseLibraryTemplatesUpsertSchema = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
    category: Yup.string(),
    description: Yup.string(),
});

export default function ExpenseLibraryTemplatesEditForm(props) {
    return (
        <Formik
            initialValues={{
                name: props.template.name ?? '',
                category: props.template.category ?? '',
                description: props.template.description ?? '',
            }}
            validationSchema={ExpenseLibraryTemplatesUpsertSchema}
            onSubmit={(values, actions) => {
                if (!props.template.id) {
                    axios
                        .post(props.templatesStoreUrl, values)
                        .then((response) => {
                            props.setTemplateIsUpdated(true);
                        })
                        .catch((e) => {
                            actions.setErrors(e.response.data.errors);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                        });
                } else {
                    axios
                        .put(props.templatesUpdateUrl.replace('EXPENSE_LIBRARY_TEMPLATE_ID', props.template.id), values)
                        .then((response) => {
                            props.setTemplateIsUpdated(true);
                        })
                        .catch((e) => {
                            actions.setErrors(e.response.data.errors);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                        });
                }
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Name')} type="text" required={true} name="name" placeholder={$t('Name')}></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Category')} type="text" name="category" placeholder={$t('Category')}></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Description')} type="text" name="description" placeholder={$t('Description')}></TextFormField>
                    </div>
                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={props.template.id ? $t('Update') : $t('Create')}
                        onCancel={props.internalCloseHandler}
                        handleSubmit={handleSubmit}
                        isSubmitting={props.request}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
